import { LanguageLevelEnum } from '../language-level.enum';

export interface LanguageSkillInterface {
  key: string;
  languageLevel: LanguageLevelEnum;
}
